(function($){

	var valDefault = $('#rezim option:selected').val();

	if (valDefault == "pre_orders"){

		$(".c-login-page .c-header__info").addClass("on");

	}else {

		$(".c-login-page .c-header__info").removeClass("on");

	}

	$('#rezim').on('change', function() {

		var value = $(this).val();

		if (value == "pre_orders"){

			$(".c-login-page .c-header__info").addClass("on");

		}else {

			$(".c-login-page .c-header__info").removeClass("on");

		}
	});

})(jQuery);


